export interface Accessorials {
   code: string;
   module: string[];
   description: string;
   isPrimary: boolean;
   selected?: boolean
}

export class Accessorials implements Accessorials {
   constructor( a?: Accessorials ) {
      this.code = a.code;
      this.module = a?.module || [];
      this.description = a?.description;
      this.isPrimary = a?.isPrimary || false;
      this.selected = a?.selected || false;
   }
}

import { FormGroup, FormControl, FormArray } from '@angular/forms';
export function accessorialsGroup( accessorials: any = {} ): FormGroup {
   return new FormGroup({
      code: new FormControl( accessorials['code'] ),
      module: new FormControl( accessorials['module'] || [] ),
      description: new FormControl( accessorials['description'] ),
      isPrimary: new FormControl( accessorials['isPrimary'] || false),
      selected: new FormControl(accessorials['selected'] || false),
   });
}

export function accessorialsArray( accessorials: Accessorials[] = []): FormArray {
   const accessorialsArray = new FormArray( [] );
   accessorials.map( d => accessorialsArray.push( accessorialsGroup( d )));

   return accessorialsArray;
}
